export const palette = {
  white: '#FFFFFF',
  black: '#000000',

  gray25: '#2c3235',
  gray15: '#22252b', //'#202226',
  gray10: '#181b1f', // old '#141619',
  gray05: '#111217', // old '#0b0c0e',

  // new from figma,
  darkLayer0: '#18181A',
  darkLayer1: '#212124',
  darkLayer2: '#2a2a2f', // figma used #34343B but a bit too bright

  darkBorder1: '#34343B',
  darkBorder2: '#64646B',

  // Dashboard bg / layer 0 (light theme)
  gray90: '#F4F5F5',
  // Card bg / layer 1
  gray100: '#F4F5F5',
  // divider line
  gray80: '#D0D1D3',
  // from figma
  lightBorder1: '#E4E7E7',

  blueDarkMain: '#3D71D9', // '#4165F5',
  blueDarkText: '#6E9FFF', // '#58a6ff', //'#33a2e5', // '#5790FF',
  redDarkMain: '#D10E5C',
  redDarkText: '#FF5286',
  greenDarkMain: '#1A7F4B',
  greenDarkText: '#6CCF8E',
  orangeDarkMain: '#F5B73D',
  orangeDarkText: '#F8D06B',

  blueLightMain: '#3871DC',
  blueLightText: '#1F62E0',
  redLightMain: '#E0226E',
  redLightText: '#CF0E5B',
  greenLightMain: '#1B855E',
  greenLightText: '#0A764E',
  orangeLightMain: '#FAD34A',
  orangeLightText: '#8A6C00',
};
